var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11.0703 12.9857",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53482 0.100391C5.64674 0.100397 5.75217 0.147458 5.84342 0.229297L9.78775 3.76836C9.98257 3.9429 9.96216 4.21781 9.80435 4.38066C9.64326 4.54679 9.38652 4.56094 9.20084 4.39434L5.96451 1.49199V10.0613C5.96432 10.3281 5.74608 10.4794 5.54752 10.4861C5.34836 10.4929 5.10514 10.336 5.10514 10.0721L5.10416 1.49102L1.86881 4.39336C1.67617 4.56637 1.408 4.54285 1.25162 4.36504C1.16887 4.27069 1.13199 4.15759 1.1442 4.04375C1.1563 3.9312 1.21488 3.82685 1.30631 3.74492L5.22623 0.229297C5.31707 0.147601 5.4228 0.100473 5.53482 0.100391Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5359 9.05742C10.7595 9.05366 10.9694 9.23039 10.9695 9.48223L10.9705 12.4432C10.9705 12.5702 10.924 12.6831 10.8406 12.7635C10.7577 12.8433 10.6442 12.8855 10.5193 12.8855L0.503711 12.8846C0.365591 12.8846 0.260834 12.8175 0.194141 12.7254C0.129516 12.6361 0.100391 12.5236 0.100391 12.4207V9.48223L0.110156 9.39043C0.154776 9.18768 0.341442 9.05469 0.533984 9.05742C0.782691 9.06138 0.95959 9.25347 0.959766 9.50664V12.0252H10.1102L10.1111 9.4832C10.1111 9.22876 10.3162 9.06118 10.5359 9.05742Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5ce1cd0f685b4ed1ad4f16dc594d4a35.svg";
export { ForwardRef as ReactComponent };